module.exports = __webpack_public_path__ + "static/media/extended.8f660629.svg";